import React from 'react';
import styled from '@emotion/styled';

const StyledButton = styled.button`
  display: inline-block;
  border: none;
  margin: 0;
  text-decoration: none;
  color: #ffffff;
  cursor: pointer;
  text-align: center;
  background-color: hsla(0,0%,0%,0.8);
  box-shadow: 0 2px 15px 0 rgba(171,171,171,0.50);
  border-radius: 8px;
  height: 40px;
  padding: 0 2.5rem;
  font-family: 'futura', 'sans-serif';
  :focus {
    outline: none;
  }
    @media (max-width: 745px) {
     padding: 6px 12px;
  }
    
`;

export default StyledButton;
